import { Context, Schema, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import { ChatThreadSummary } from "@workerstation/shared/chat-contract";
import { WorktreeResponses } from "@workerstation/shared/station/worktree";
import type { RecentStation } from "../recent-stations.ts";
export const ChatReviewTarget = Schema.Struct({ stationId: Schema.String, threadId: Schema.String, proposalId: Schema.String, worktreeId: Schema.String });
export type ChatReviewTarget = typeof ChatReviewTarget.Type;
export const ChatReviewSnapshot = Schema.Union([
  Schema.Struct({ status: Schema.Literals(["idle", "loading", "error"]) }),
  Schema.Struct({ status: Schema.Literal("loaded"), response: WorktreeResponses["worktree.diff"] })
]);
export type ChatReviewSnapshot = typeof ChatReviewSnapshot.Type;
export interface ChatReviewSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ChatReviewSnapshot>>;
  readonly load: Effect.Effect<void>;
}
export class ChatReviews extends Context.Service<ChatReviews, {
  readonly open: (target: ChatReviewTarget) => Effect.Effect<ChatReviewSession, never, Scope.Scope>;
}>()("workerstation/frontend/ChatReviews") {}
export const LauncherSnapshot = Schema.Struct({
  stations: Schema.Array(Schema.Struct({ stationId: Schema.String, openedAt: Schema.Number })),
  selected: Schema.NullOr(Schema.String), threads: Schema.NullOr(Schema.Array(ChatThreadSummary)), error: Schema.NullOr(Schema.String)
});
export type LauncherSnapshot = typeof LauncherSnapshot.Type;
export type LauncherCommand = { readonly _tag: "Select"; readonly stationId: string | null }
  | { readonly _tag: "Forget"; readonly stationId: string } | { readonly _tag: "Create" }
  | { readonly _tag: "Open"; readonly stationId: string; readonly threadId?: string };
export class LauncherBrowserIo extends Context.Service<LauncherBrowserIo, {
  readonly recent: Effect.Effect<readonly RecentStation[]>;
  readonly forget: (stationId: string) => Effect.Effect<readonly RecentStation[]>;
  readonly create: Effect.Effect<string>;
  readonly open: (stationId: string, threadId?: string) => Effect.Effect<void>;
}>()("workerstation/frontend/LauncherBrowserIo") {}
export interface ChatLauncherSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<LauncherSnapshot>>;
  readonly dispatch: (command: LauncherCommand, open?: (stationId: string, threadId?: string) => Effect.Effect<void>) => Effect.Effect<void>;
}
export class ChatLaunchers extends Context.Service<ChatLaunchers, {
  readonly open: Effect.Effect<ChatLauncherSession, never, Scope.Scope>;
}>()("workerstation/frontend/ChatLaunchers") {}
